/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
import {
    fork, takeLatest, call, put,
} from 'redux-saga/effects';
import mbpLogger from 'mbp-logger';

import {
    getClientIdGooglePay,
    loadClientIdGooglePay,
    clearClientIdGooglePay,
    placeOrderGooglePay,
} from './GooglePay-Actions';
import {
    normalizeGooglePaymentBillingAddress,
} from './GooglePay-Helper';

import cartServiceClient from '../../../../../../../apis/cart-service-apis/cartServiceClient';
import { flagOffShowLoadingMessage, updateShowLoadingMessage } from '../../../../../Common/ducks/ShowLoadingMessage/ShowLoadingMessage-Actions';
import { checkJWT } from '../../../../../Checkout/ducks/Global/Global-Operations';
import { updateBillingAddressForm } from '../../BillingAddress/BillingAddress-Actions';
import { paymentPlaceOrder } from '../../PlaceOrder/PlaceOrder-Actions';

function* workerGetClientIdGooglePay() {
    try {
        mbpLogger.logDebug({
            appName: process.env.npm_package_name,
            module: 'mbp-pwa-ui',
            function: 'workerGetGooglePayClientId',
            message: 'Get Google Pay Client Id',
        });

        // show loader
        yield put(updateShowLoadingMessage());

        const jwtToken = yield call(checkJWT);

        const payload = {
            env: {},
            jwtToken,
            paymentMethod: 'GooglePay',
        };

        // Get Paypal Session Client Token
        const response = yield call(cartServiceClient.paymentClientToken, payload);
        const { clientToken } = response.data;
        yield put(clearClientIdGooglePay());
        yield put(loadClientIdGooglePay(clientToken));

        // hide loader
        yield put(flagOffShowLoadingMessage());
    } catch (ex) {
        mbpLogger.logError({
            appName: process.env.npm_package_name,
            module: 'mbp-pwa-ui',
            function: 'workerGetGooglePayClientId',
            jsError: ex,
            message: 'Failed in getting google client id',
        });
        yield put(flagOffShowLoadingMessage());
    }
}

function* workerPlaceOrderGooglePayCheckout(action) {
    try {
        mbpLogger.logDebug({
            appName: process.env.npm_package_name,
            module: 'mbp-pwa-ui',
            function: 'workerSubmitGooglePayment',
            message: 'Submit Google Pay Payment',
        });

        const {
            paymentDataResponse,
            result,
            history,
            isCheckout,
        } = action.data;

        const billingAddress = normalizeGooglePaymentBillingAddress(paymentDataResponse);
        billingAddress.isFormValid = true;

        const paymentCardType = result?.details?.cardType || '';
        const cardlastFourDigit = result?.details?.lastFour || '';

        yield put(updateBillingAddressForm(billingAddress));

        const placeOrderConfig = {
            history,
            isCheckout,
            params: {},
            disablePaymentFields: false,
            source: 'PWA',
            googlePayment: {
                nonce: result.nonce,
                billingAddress,
                paymentCardType,
                cardlastFourDigit,
            },
        };

        yield put(paymentPlaceOrder(placeOrderConfig));
    } catch (ex) {
        mbpLogger.logError({
            appName: process.env.npm_package_name,
            module: 'mbp-pwa-ui',
            function: 'workerSubmitGooglePayment',
            jsError: ex,
            message: 'Failed submitting GooglePay payment',
        });
    }
}

function* watcherPlaceOrderGooglePay() {
    yield takeLatest(placeOrderGooglePay().type, workerPlaceOrderGooglePayCheckout);
}

function* watcherGetClientIdGooglePay() {
    yield takeLatest(getClientIdGooglePay().type, workerGetClientIdGooglePay);
}

const watchers = [
    fork(watcherGetClientIdGooglePay),
    fork(watcherPlaceOrderGooglePay),
];

export {
    watchers,
};

export default {};
